import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { RackingAreaType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/RackingAreaType';
import RackingLoadHandlingType from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/RackingLoadHandlingType';
import Alignment from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/Alignment';
import { VehicleType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/VehicleType';
import { OffsetDriving } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/OffsetDriving';
import { Margin } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/Margin';
import AlongsideExtension from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/AlongsideExtension';
import InsideExtension from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/InsideExtension';
import { RackingPoiPreferences } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/RackingPoiPreferences';
import { RackingConnectNeighbors } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/RackingConnectNeighbors';
import { RackSpec } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/racking/RackSpec';
import { LoadType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/singularStation/LoadType';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { AreaDimensions } from './AreaDimensions';

function RackingAreaParametersComponent() {
  const selectedAreas = useReadSelectedAreas();
  const selectedRackingArea =
    selectedAreas.rackingAreas.length === 1 ? selectedAreas.rackingAreas[0] : null;

  if (!selectedRackingArea) return null;

  return (
    <Stack spacing={1} divider={<Divider />}>
      <AreaDimensions />
      <Accordion
        title={t<string>('interface:properties.racking_area.title', 'Rack Area')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1} pb={2}>
          <PropertiesLabel i18nkey='interface:properties.area.rack.racking_type.label'>
            <RackingAreaType />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:properties.area.load_handling_type'>
            <RackingLoadHandlingType />
          </PropertiesLabel>
          <LoadType />
          <PropertiesLabel i18nkey='interface:properties.area.alignment'>
            <Alignment />
          </PropertiesLabel>
          <Margin />
          <OffsetDriving />
          <AlongsideExtension />
          <InsideExtension />
          <RackingPoiPreferences selectedRackingArea={selectedRackingArea} />
          <PropertiesLabel i18nkey='interface:properties.area.connect_neighbors'>
            <RackingConnectNeighbors />
          </PropertiesLabel>
          <VehicleType />
        </Stack>
      </Accordion>
      <RackSpec />
    </Stack>
  );
}

export const RackingAreaParameters = memo(RackingAreaParametersComponent);
